import { ContentType } from 'enums';

export default function convertV1ToV3(content) {
    let v3Content;
    if (content.type === 'event') {
        v3Content = {
            id: `${content.id}`,
            status: content.status,
            type: ContentType.LISTING,
            name: content.name,
            description: content.description,
            imageHref: content.imageHref,
            subtitle: content.subtitle,
            date: content.date,
            shortDate: content.shortDate,
            utc: content.rawDate,
            time: content.time,
            streams: [{
                id: `${content.id}`,
                name: content.name,
                status: content.status,
                duration: content.duration,
                source: {
                    id: content.sourceId,
                    name: content.source,
                    type: content.sourceType
                },
                score: content.score,
                authTypes: content.authTypes,
                adobeRSS: content.adobeRSS,
                links: content.links
            }],
            iconHref: content.iconHref
        };
    } else if(content.type === 'video') {
        v3Content = {
            id: `${content.id}`,
            guid: content.guid,
            type: ContentType.VOD,
            name: content.name,
            description: content.description,
            imageHref: content.imageHref,
            subtitle: content.subtitle,
            streams: [{
                id: `${content.id}`,
                name: content.name,
                duration: content.duration,
                source: {
                    name: content.source
                },
                links: content.links
            }]
        };
    }
    return v3Content;
}



// WEBPACK FOOTER //
// ./app/lib/format/convertV1ToV3.js